export default "__VITE_ASSET__CWanm2Jt__"